/**
 * @file    js/global.js
 *
 * copyright (c) 2006-2022 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

import '../sass/global.scss';

import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import { MagazineNavigator } from '@depage/magaziner';;
import Cookies from 'js-cookie';
import '@accessible360/accessible-slick';
import './depage-jquery-plugins/depage-email-antispam';
import './depage-jquery-plugins/depage-slideshow';
import './depage-jquery-plugins/depage-details';
import { CountUp } from 'countup.js';
import * as klaro from 'klaro/dist/klaro';
import Hypher from 'hypher';
import hdef from 'hyphenation.de/lib/de';

// export jQuery to global scope for plugins that expect it
globalThis.$ = $;
globalThis.jQuery = $;

// {{{ klaroConfig
var klaroConfig = {
	testing: false,
	htmlTexts: true,
	acceptAll: true,
	translations: {
		zz: {
			privacyPolicyUrl: '/en/data-protection',
		},
		de: {
			privacyPolicyUrl: '/datenschutz',
			consentNotice: {
				description: 'Wir speichern und verarbeiten Ihre personenbezogenen Informationen für folgende Zwecke: <strong>{purposes}</strong>.\n',
				learnMore: 'Mehr erfahren...',
			},
			decline: 'Ablehnen',
			ok: 'Zustimmen',
			acceptSelected: 'Ausgewählte akzeptieren',
			consentModal: {
				title: 'Dienste, die wir nutzen möchten',
				description:
					'Hier können Sie einsehen und anpassen, welche Information wir über Sie ' +
					'sammeln.',
			},
			privacyPolicy: {
				name: 'Datenschutzerklärung',
			},
			service: {
				disableAll: {
					description: 'Mit diesem Schalter können Sie alle Dienste aktivieren oder deaktivieren.',
				},
			},
			purposes: {
				analytics: {
					title: 'Besucher-Statistiken'
				},
				userexperience: {
					title: 'Verbesserung der Nutzungserfahrungen'
				},
				functionality: {
					title: 'Funktionalität'
				},
			},
		},
		en: {
			privacyPolicyUrl: '/en/data-protection',
			consentModal: {
				description:
					'Here you can see and customize the information that we collect about you.',
			},
			purposes: {
				analytics: {
					title: 'Analytics'
				},
				userexperience: {
					title: 'Optimization of Userexperience'
				},
				functionality: {
					title: 'Functionality'
				},
			},
		},
	},
	services: [
		{
			name: 'piwik',
			default: false,
			translations: {
				zz: {
					title: 'Matomo'
				},
				en: {
					description: 'Matomo is used for website analysis. It generates statistical data on how the visitor uses the website.'
				},
				de: {
					description: 'Matomo wird zur Website-Analyse verwendet. Es erzeugt statistische Daten darüber, wie der Besucher die Website nutzt.'
				},
			},
			purposes: ['analytics'],
			required: false,
			optOut: false,
			onlyOnce: true,
		},
		{
			name: 'video',
			default: false,
			translations: {
				zz: {
					title: 'YouTube'
				},
				en: {
					description: 'Display of external videos.'
				},
				de: {
					description: 'Anzeige von externen Videos.'
				},
			},
			callback: function(consent) {
				if(consent == true){
					$('.hide-on-cookieconsent-video').hide();
					$('.hide-on-cookieconsent-video').next('iframe').show();
				}
				if(consent == false){
					$('.hide-on-cookieconsent-video').next('iframe').hide();
				}
			},
			purposes: ['userexperience'],
			required: false,
			optOut: false,
		},
		{
			name: 'required',
			default: true,
			translations: {
				zz: {
					title: 'Essential Cookies'
				},
				en: {
					description: 'These cookies are required so that the basic functions of the website can be operated. For example, setting anonymous session IDs to bundle queries.'
				},
				de: {
					description: 'Diese Cookies werden benötigt, damit Basisfunktionen der Webseite bedient werden können. Zum Beispiel das Setzen von anonymen Session ID\'s zur Bündelung von Abfragen.'
				},
			},
			purposes: ['functionality'],
			required: true,
			optOut: false,
		}
	],
};
// }}}

klaro.setup(klaroConfig);

var bga = (function() {
    "use strict";
    /*jslint browser: true*/
    /*global $:false */

    var lang = $('html').attr('lang');
    var $sidebar,
        $html,
        $body;
    var smc = new ScrollMagic.Controller();

    // return integer random number between min and max
    // min and max are inclusive
    var rand = function(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // local Project instance that holds all variables and public functions
    var localJS = {
        // {{{ ready
        ready: function() {
            $html = $('html'),
            $body = $('body');

            $html.addClass("javascript");

            new ScrollMagic.Scene({
                    offset: 100,
                })
                .addTo(smc)
                .setClassToggle($body.children("header")[0], "not-on-top");

            // workaround for lightbox links not having the no-ajaxy class
            $("a.lightbox").addClass("no-ajaxy");

            localJS.setupTeaserClick();
            localJS.setupMagaziner();
            localJS.setupSidebar();
            localJS.setupSearch();

            localJS.setup();
        },
        // }}}
        // {{{ setup
        setup: function($main) {
            if (typeof $main == 'undefined') {
                $main = $html;
            }

            localJS.setupVarious($main);
            localJS.setupSlider($main);
            localJS.setupSlideshows($main);
            localJS.setupSubnav($main);
            localJS.setupScenes($main);
            localJS.setupCountUp($main);
            localJS.setupHyphenation($main);
            localJS.setupRotatingSlider($main);
            localJS.setupLightbox($main);
            localJS.setupFlipbook($main);
        },
        // }}}
        // {{{ setupTeaserClick
        setupTeaserClick: function() {
            document.addEventListener('click', function(e) {
                var teaser = e.target.closest('.teaser');
                if (!teaser) return;

                var link = teaser.querySelector('a');
                if (!link) return;

                if (e.target.closest('a') === link) return;

                e.preventDefault();
                link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            });
        },
        // }}}
        // {{{ setupVarious
        setupVarious: function($main) {
            // force images/videos to download
            $main.find("a[href$='.png'], a[href$='.jpg'], a[href$='.jpeg'], a[href$='.mp4'], a[href$='.m4v'], a[href$='.pptx'], a[href$='.docx'], a[href$='.zip']").not(".lightbox").attr("download", "").addClass("download");

            $(".details", $main).depageDetails({
                "head": "header.detail-header"
            });

            // @todo find a better solution for this
            $("main > .section > .content > .right-col").each(function() {
                var $this = $(this);
                var $target = $(".newsarticle .right-col");

                if ($target.length == 0) {
                    return;
                }

                $this.children().appendTo(".newsarticle .right-col");
                $this.remove();
            });
        },
        // }}}
        // {{{ setupScenes
        setupScenes: function($main) {
            var smcScenes = [];

            $main.find(".sm-anim").each(function() {
                var el = this;
                var $el = $(this);
                var st = el.style;
                var hook = 0.7;
                var pinned = $el.hasClass("pinned");
                if ($el.is(":last-child")) {
                    hook = 0.85;
                }
                if ($el.hasClass("timeline-entry")) {
                    hook = 0.95;
                }
                if (pinned) {
                    hook = 0;
                }

                var s = new ScrollMagic.Scene({
                        triggerElement: el,
                        duration: "100%",
                        triggerHook: hook
                    })
                    .addTo(smc)
                    .setClassToggle(el, "in-view")
                    .on("progress", function(e) {
                        st.setProperty('--sm-progress', e.progress.toFixed(4));
                        st.setProperty('--sm-progress-sin', Math.sin(e.progress * 2 * Math.PI).toFixed(4));
                        st.setProperty('--sm-progress-cos', Math.cos((1 - e.progress) * 2 * Math.PI).toFixed(4));
                    });

                smcScenes.push(s);

                $el.find(".sm-anim-child").each(function(i) {
                    var sub = this;
                    var s = new ScrollMagic.Scene({
                            triggerElement: el,
                            triggerHook: hook,
                            offset: (-30 + 50 * i) + "%"
                        })
                        .addTo(smc)
                        .setClassToggle(sub, "in-view");

                    smcScenes.push(s);
                });
            });
            $main.data("smcScenes", smcScenes);
        },
        // }}}
        // {{{ setupRotatingSlider
        setupRotatingSlider: function($main) {
            $main.find(".rotating-slider").each(function() {
                var $el = $(this);
                var $slides = $el.find("li:not(.flex-spacer)");
                var current = parseInt(Cookies.get("bga-current-topic"), 10) || rand(0, $slides.length - 1);
                var baseDegree = (360 / $slides.length);
                var maxDegree = 360 - (360 / $slides.length);
                var currentProgress = 0;
                var dragScaling = 0.01;
                var $window = $(window);
                var updateDragScaling = function() {
                    var w = Math.min(1600, Math.max(800, $window.width()));
                    dragScaling = 0.01 * (w / 1000);
                };
                var resizeTimer = null;

                $window.on("resize orientationchange", function() {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout( updateDragScaling, 200 );
                });

                var updateRotation = function(n) {
                    var addedRotation = n * baseDegree;

                    $slides.each(function(i) {
                        var rotation = currentProgress * maxDegree + i * baseDegree - 90 + addedRotation;
                        var opacity = (Math.sin(rotation * (Math.PI/180)) + 1) * 0.5;
                        var zIndex = Math.floor(opacity * 10) + 1;

                        this.style.setProperty("--inner-degree", rotation.toFixed(3));
                        this.style.setProperty("--inner-depth", opacity.toFixed(3));
                        this.style.setProperty("--inner-z-index", zIndex);
                    });
                };
                var setCurrent = function(n) {
                    current = n;

                    Cookies.set("bga-current-topic", n % $slides.length, {
                        expires: 60 * 60, // 1 hour
                        sameSite: "Strict"
                    });

                    $el.addClass("animated");
                    updateRotation(current);
                };

                $el.addClass("animated");
                $el.children("button").remove();

                $("<button class=\"slick-prev slick-arrow\" aria-label=\"Previous\" type=\"button\">Previous</button>")
                    .on("click", function() {
                        setCurrent(current - 1);
                    })
                    .appendTo($el);
                $("<button class=\"slick-next slick-arrow\" aria-label=\"Next\" type=\"button\">Next</button>")
                    .on("click", function() {
                        setCurrent(current + 1);
                    })
                    .appendTo($el);

                // {{{ horizontal scrolling between slides
                let startX = 0;
                let startTime = performance.now();
                this.addEventListener('touchstart', (e) => {
                    if (e.pointerType === 'mouse') return;

                    startX = e.touches[0].clientX;
                    this.classList.remove('animated');
                });
                this.addEventListener('touchmove', (e) => {
                    if (e.pointerType === 'mouse') return;

                    const dx = e.changedTouches[0].clientX - startX;

                    updateRotation(current + dx * dragScaling);
                });
                this.addEventListener('touchend', (e) => {
                    if (e.pointerType === 'mouse') return;

                    const dx = e.changedTouches[0].clientX - startX;
                    const elapsed = performance.now() - startTime;
                    const velocity = Math.abs(dx) / (elapsed || 1);

                    setCurrent(current + Math.round(dx * dragScaling + 0.5 * velocity));
                });
                // }}}

                updateDragScaling();
                setCurrent(current);
            });
        },
        // }}}
        // {{{ setupSlider
        setupSlider: function($main) {
            $main.find(".topics.slider:not(.slick-initialized)").slick({
                slide: "div:not(.flex-spacer)",
                rows: 0,
                initialSlide: 0,
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true,
                responsive: [{
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            });
            $main.find(".teasers.slick:not(.slick-initialized)").slick({
                slide: ".teaser:not(.flex-spacer)",
                rows: 0,
                initialSlide: 0,
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                responsive: [{
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 600,
                    settings: "unslick"
                }]
            });
        },
        // }}}
        // {{{ setupMagaziner
        setupMagaziner: function() {
            var pagecontainer = document.getElementById("pagecontainer");
            var $navMain = $("nav.main");

            var magaziner = new MagazineNavigator(pagecontainer, "nav.main a, nav.pages a", {
                preloadPageTimeout: -1,
                keyboardNavigation: false,
                touchNavigation: false,
            });

            if (!magaziner) return;

            pagecontainer.addEventListener("depage-magaziner:loaded", function(e) {
                const page = e.detail.page;
                localJS.setup($(page));
            });

            pagecontainer.addEventListener("depage-magaziner:statechangecomplete", function(e) {
                const page = e.detail.page;
                var $navFooter = $(page).find("nav.footer").children("ul");

                $navMain.empty().append($navFooter.clone(true));

                $sidebar.removeClass("menu-open");
                $body.removeClass("search-open");
            });
            pagecontainer.addEventListener("depage-magaziner:show", function(e) {
                const page = e.detail.page;
                window.scrollTo(0,0);

                localJS.setupVarious($(page));

                klaro.getManager().applyConsents();
            });
            pagecontainer.addEventListener("depage-magaziner:removed", function(e) {
                const page = e.detail.page;
                var $page = $(page);
                var smcScenes = $page.data("smcScenes");
                if (smcScenes) {
                    smc.removeScene(smcScenes);
                }
                $page.find(".teasers.slick, .topics.slider").slick("unslick");
            });
        },
        // }}}
        // {{{ setupSlideshows
        setupSlideshows: function($main) {
            var $slideshows = $main.find(".slideshow").each( function() {
                var $slideshow = $(this);

                $slideshow.depageSlideshow({
                    elements: "figure, div",
                    speed: 1000,
                    pause: 6000
                });

                var slideshowController = $(this).data("depage.slideshow");


                $slideshow.children("button").remove();

                if (slideshowController.num > 1) {
                    $("<button class=\"slick-prev slick-arrow\" aria-label=\"Previous\" type=\"button\">Previous</button>")
                        .on("click", function() {
                            slideshowController.prev();
                        })
                        .appendTo($slideshow);
                    $("<button class=\"slick-next slick-arrow\" aria-label=\"Next\" type=\"button\">Next</button>")
                        .on("click", function() {
                            slideshowController.next();
                        })
                        .appendTo($slideshow);
                }
            });
        },
        // }}}
        // {{{ setupLightbox
        setupLightbox: async function($main) {
            var $lighboxLinks = $main.find("a.lightbox").addClass("no-ajaxy");

            if ($lighboxLinks.length == 0) {
                return;
            }

            await import('jquery-colorbox/jquery.colorbox');

            $lighboxLinks.colorbox({
                maxWidth: '100%',
            });
        },
        // }}}
        // {{{ setupFlipbook
        setupFlipbook: function($main) {
            setTimeout( function() {
                $main.find(".flipbook").each( function() {
                    var $flipbook = $(this);
                    var src = $flipbook.attr("source");

                    $flipbook.empty();

                    DEARFLIP.defaults.enableSound = false;

                    $flipbook.flipBook(src);
                });
            }, 1 );
        },
        // }}}
        // {{{ setupHyphenation
        setupHyphenation: async function($main) {
            // hyphenate text
            try {
                var hypher = new Hypher(hdef);;
                $("article > p, article > p > a, h1, h2, h3, h1 a, h2 a, h3 a, h1 span, h2 span, h3 span, .text p, .teaser p, .intro p, .teasers.navigation a span, .number-teaser > span", $main).each(function() {
                    var i = 0, len = this.childNodes.length;

                    for (; i < len; i += 1) {
                        if (this.childNodes[i].nodeType === 3) {
                            this.childNodes[i].nodeValue = hypher.hyphenateText(this.childNodes[i].nodeValue);
                        }
                    }
                });
            } catch (e) {
                // ignore
            }
        },
        // }}}
        // {{{ setupCountUp
        setupCountUp: function() {
            let $numbers = $(".number-teaser > .number > strong");
            const separator = lang === "de" ? "." : ",";
            const decimal = lang === "de" ? "," : ".";
            $numbers.each( function(i) {
                let endVal = parseInt($(this).text().replace(/\./g, ''));
                const countUp = new CountUp(this, endVal, { 
                    enableScrollSpy: true,
                    duration: i * 0.25 + 1.5,
                    separator: separator,
                    decimal: decimal,
                });
            });
        },
        // }}}
        // {{{ setupSidebar
        setupSidebar: function() {
            $sidebar = $("nav.sidebar");
            $sidebar.children(".burger-icon").on("click", function() {
                $body.removeClass("search-open");
                $sidebar.toggleClass("menu-open");
            });
        },
        // }}}
        // {{{ setupSubnav
        setupSubnav: function($main) {
            var $subnav = $main.find("nav.mobilesub");
            var $header = $subnav.children(".subnav-header");

            $header.children("a").off("click").on("click", function(e) {
                $subnav.toggleClass("active");

                e.stopPropagation();
                e.preventDefault();
            })
        },
        // }}}
        // {{{ setupSearch
        setupSearch: function() {
            var $searchLink = $("nav.search");

            $searchLink.off("click").on("click", function() {
                $body.toggleClass("search-open");
                $sidebar.removeClass("menu-open");

                $(".tx-indexedsearch-searchbox-sword").focus();
            });
        }
        // }}}
    };

    return localJS;
})();

// {{{ register ready event
$(document).ready(function() {
    bga.ready();
});
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
